import { auth, ref } from 'constants/firebase'
import { SCRAP_URL } from 'constants/index'
import * as integrationType from 'constants/integrationType'
import firebase from 'firebase'
import _ from 'lodash'
import { createCustomFields } from 'templates/app-website/template/mobileApp'
import history from 'components/history'

function * getAppInfoSimple (platform, appId) {
  try {
    const body = {
      platform: platform,
      command: 'appAndReviews',
      options: {
        appId: appId
      }
    }
    const options = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }
    const response = yield fetch(SCRAP_URL, options)
    const data = yield response.json()
    return data
  } catch (e) {
    return null
  }
}

function * createApp (userId, params) {
  const appIdDots = `${params.platform}.${params.appId}`
  const appId = _.join(_.split(appIdDots, '.'), '_')
  const appSN = yield ref.child('users').child(userId).child('apps').child(appId).once('value')
  const appExists = !_.isNil(appSN.val())
  if (appExists) {
    // console.log('app exists', appSN.val())
    history.push(`/app/${appId}`)
    return null
  } else {
    const data = yield getAppInfoSimple(params.platform, params.appId)
    if (_.isNil(data)) return null
    const customFields = createCustomFields(data.result, params.platform === 'ios')
    _.set(customFields, 'appSettings.integration.type', integrationType.MOBILE_APP)
    _.set(customFields, 'appSettings.integration.platform', params.platform)
    _.set(customFields, 'appSettings.integration.appId', params.appId)
    const app = {
      id: appId,
      name: appId,
      customFields,
      createdAt: firebase.database.ServerValue.TIMESTAMP,
      templateId: customFields.templateId
    }
    yield ref.child('users').child(userId).child('apps').child(appId).set(app)
    const info = {
      userId: userId,
      appId: appId,
      createdAt: firebase.database.ServerValue.TIMESTAMP
    }
    yield ref.child('sandbox').child(appId).set(info)
    history.push(`/app/${appId}`)
    return null
  }
}

export function initWebSite (params) {
  return function * (dispatch, getState) {
    console.log('initWebSite', params)
    if (auth.currentUser === null) {
      const authData = yield auth.signInAnonymously()
      yield createApp(authData.uid, params)
    } else {
      yield createApp(auth.currentUser.uid, params)
    }
  }
}

export function getAppInfo (platform, appId, callback) {
  return function * (dispatch, getState) {
    console.log('getAppInfo', platform, appId)
    const data = yield getAppInfoSimple(platform, appId)
    if (_.has(data, 'result')) {
      callback(data.result)
    } else {
      callback(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/webSite.js